import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';

const AgreementExpiredSummary = () => (
    <StatusSummaryButton
        href="/be-om-nytt-avtaleforslag"
        statusSummary="Avtaleforslaget har gått ut på tid."
        actionRequiredType="NEGATIVE"
    >
        Be om et nytt avtaleforslag
    </StatusSummaryButton>
);

export default AgreementExpiredSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/summaries/agreementExpiredSummary.jsx